import HTTPServices from "../HTTPServices/httpService";

const measurementSettingsDetailsServices = {
  //(**) Get Measurement settings Details by Settings ID
  getBySettingsID: async function (settingsID) {
    console.log("'Get all measurement settings Details' service called: '");
    let result = await HTTPServices.post(
      "measurementSettingsDetails/getMeasurementSettingsDetailsBySettingID",
      settingsID
    );
    console.log("retrun result --->" + result);
    return result;
  },

  //(**) Get Measurement settings Details by Settings ID
  getByGUID: async function (guid) {
    console.log("'Get the measurement settings Details' service called: '");
    let result = await HTTPServices.post(
      "measurementSettingsDetails/GetMeasurementSettingsDetails_By_GUID",
      guid
    );
    console.log("retrun result --->" + JSON.stringify(result));
    return result;
  },
  //(2)
  save: async function (savingObj) {
    console.log(
      "'measurementSettingsDetailsServices' service called: save : " +
        JSON.stringify(savingObj)
    );
    let measurementSettingsDetailObj = await HTTPServices.post(
      "measurementSettingsDetails/save",
      savingObj
    );
    // customer.then((result) => {
    //   debugger;
    //   console.log("Promised result: " + result); // "Some desired value"
    //   return result;
    // });

    return measurementSettingsDetailObj;
  },
  searchByCustomerGUID: async function (customerGUID) {
    console.log(
      "'customerServices' service called: searchByCustomerGUID: " + customerGUID
    );
    let customerGot = await HTTPServices.get(
      "customer/getByID/" + customerGUID
    );
    console.log("result got: " + customerGot.name);
    return customerGot;
  },

  deleteByGUID: async function (guid) {
    console.log(" Delete of Measurement Settings Details -> guid: " + guid);
    let result = await HTTPServices.post(
      "measurementSettingsDetails/deleteMeasurementSettingsDetailsByGUID",
      guid
    );
    console.log("retrun result --->" + result);
    return result;
  },
};

export default measurementSettingsDetailsServices;
